<template>
  <div
    class="
      [&_button]:!h-[56px] [&_button]:!bg-main-blue [&_button]:!px-8 [&_button]:!text-white
      [&_button]:!duration-300 [&_button]:md:w-min
    "
  >
    <slot />
  </div>
</template>
